let loader = null
let lock = false

const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)

const SpinnerService = {
    show: function(container = null) {
        if (loader === null && !lock) {
            if (urlParams.get('external')) {
                parent.postMessage({ spinner: 'show' }, "*")
                loader = true
            } else {
                loader = document.createElement('div')
                loader.classList.add('sb-loading-overlay')
                // loader.appendChild(document.querySelector('#loading-template :first-child').cloneNode(true))

                let parent = document.querySelector(container || 'body')
                parent.classList.add('sb-loading-overlay-open')
                parent.appendChild(loader)
            }
        }
    },

    hide: function() {
        if(!lock && loader) {
            if (urlParams.get('external')) {
                parent.postMessage({ spinner: 'hide' }, "*")
            } else {
                loader.parentElement.classList.remove('sb-loading-overlay-open')
                loader.remove()
            }
            loader = null
        }
    },
    lock() {
        lock = true
    },
    unlock() {
        lock = false
    },
}

export default SpinnerService